import { render } from "./SurvivalLeader.vue?vue&type=template&id=749aa09a&scoped=true"
import script from "./SurvivalLeader.vue?vue&type=script&lang=js"
export * from "./SurvivalLeader.vue?vue&type=script&lang=js"

import "./SurvivalLeader.vue?vue&type=style&index=0&id=749aa09a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749aa09a"]])

export default __exports__